<template>
  <div class="agree">
    <div class="check-group">
      <div class="all-box">
        <v-checkbox v-model="userData.agreeAll" on-icon="mdi-check-circle" off-icon="mdi-check-circle-outline"
          label="전체 동의합니다." @click="clickAll(userData.agreeAll)" />
        <div class="info-text">
          선택 항목에 동의하지 않은 경우도<br />
          회원가입 및 일반적인 서비스를 이용할 수 있습니다.
        </div>
      </div>

      <div class="checkbox-row">
        <v-checkbox required v-model="userData.agreeTerms" on-icon="mdi-check-circle"
          off-icon="mdi-check-circle-outline" label="개인정보의 수집 및 이용에 대한 동의" :rules="[
            () => !!userData.agreeTerms || '개인정보의 수집 및 이용에 대한 동의는 필수 입니다.',
          ]">
          <template v-slot:label>
            개인정보의 수집 및 이용에 대한 동의 <span class="text-red">(필수)</span>
          </template>
        </v-checkbox>
        <v-btn icon x-small @click="clickAgreeDetail('term')">
          <v-icon>mdi-arrow-right-circle-outline</v-icon>
        </v-btn>
      </div>
      <div class="checkbox-row">
        <v-checkbox required v-model="userData.agreePolicy" on-icon="mdi-check-circle"
          off-icon="mdi-check-circle-outline" label="개인정보의 제3자 제공에 대한 동의" :rules="[
            () => !!userData.agreePolicy || '개인정보의 제3자 제공에 대한 동의는 필수 입니다.',
          ]">
          <template v-slot:label>
            개인정보의 제3자 제공에 대한 동의 <span class="text-red">(필수)</span>
          </template>
        </v-checkbox>
        <v-btn icon x-small @click="clickAgreeDetail('policy')">
          <v-icon>mdi-arrow-right-circle-outline</v-icon>
        </v-btn>
      </div>
      <div class="checkbox-row">
        <v-checkbox required v-model="userData.marketing" on-icon="mdi-check-circle" off-icon="mdi-check-circle-outline"
          label="마케팅 정보 수신 동의">
          <template v-slot:label>
            마케팅 정보 수신 동의 <span>(선택)</span>
          </template>
        </v-checkbox>
        <v-btn icon x-small @click="clickAgreeDetail('marketing')">
          <v-icon>mdi-arrow-right-circle-outline</v-icon>
        </v-btn>
      </div>
    </div>


    <!-- 약관 상세보기 팝업 -->
    <SignUpAgreeDetailDialog ref="SignUpAgreeDetailDialog" />
  </div>
</template>

<script>
import Stepper from "./agree/Stepper.vue";
import SignUpAgreeDetailDialog from "./agree/SignUpAgreeDetailDialog.vue";
export default {
  components: {
    SignUpAgreeDetailDialog,
    Stepper,
  },
  props: {
    userData: {
      type: Object,
    },
  },
  methods: {
    clickAll(e) {
      this.userData.agreeTerms = true;
      this.userData.agreePolicy = true;
      this.userData.checkAge = true;
      this.userData.marketing = true;
      if (!e) {
        this.userData.marketing = false;
        this.userData.agreeTerms = false;
        this.userData.checkAge = false;
        this.userData.agreePolicy = false;
      }
    },
    clickAgreeDetail(tab) {
      switch (tab) {
        case 'term':
          this.$refs.SignUpAgreeDetailDialog.open(tab);
          break;
        case 'policy':
          this.$refs.SignUpAgreeDetailDialog.open(tab);
          break;
        case 'marketing':
          this.$refs.SignUpAgreeDetailDialog.open(tab);
          break;
      }
    },
    clickNext() {
      if (!this.$refs.form.validate()) return;
      this.userData.checkSms = false;
      this.$emit("clickNext", "sms");
    },
    clickCancel() {
      this.$emit("clickCancel");
    },
    clickBack() {
      this.$emit("clickBack");
    }
  },
};
</script>

<style lang="scss">
.hGap {
  height: 10px;
}

.step-title {
  text-align: center;
  margin-bottom: 20px;
}

.agree {
  padding: 0;

  .section-inner {
    max-width: 800px;
  }

  .signup-header {
    padding: 1rem;
    text-align: center;
    //background: $mid-green;
    color: #ffffff;
  }

  .check-group {
    // padding: 2rem 20px 1rem;

    .all-box {
      font-weight: bold;
      border-bottom: 1px solid #ddd;

      .v-messages {
        min-height: 0 !important;
      }

      .info-text {
        font-size: 12px;
        font-weight: 400;
        padding: 0 0 15px 0;
        line-height: 1.2em;
      }
    }
  }

  .checkbox-row {
    position: relative;

    .v-input--checkbox {
      margin-top: 10px;

      &:not(.error--text) {
        .v-input__slot {
          margin-bottom: 0;
        }

        .v-messages {
          display: none;
        }
      }

      .v-label {
        font-size: 12px;

        span {
          display: inline-block;
          margin-left: 5px;

          &:not(.text-red) {
            color: #aaa;
          }
        }
      }
    }

    .v-btn {
      position: absolute;
      right: 0;
      top: 11px;
      background: #ffffff;

      .v-icon {
        color: $primary-btn-color;
      }
    }
  }
}

// @media (max-width: 768px) {
//   div.agree {
//     padding: 4rem 0 8rem;
//   }
// }</style>
